import { GroupedRequestGroup, GroupedRequestPage } from '@/core/enums/group-request.enum';
import { api } from '@/core/helpers/axiosHelper';
import { SQUAD_FILTER_ENDPOINTS } from './squad-filter.endpoints';
import { SquadFilter } from './squad-filter.interface';

export default {
   async getByBoardId(
      board_id: number,
      only_planning_confirmation: boolean,
      fill_rate_from?: string,
      fill_rate_to?: string,
      view?: string,
   ) {
      return await api
         .get(`/squad-filter`, {
            params: {
               'filter[board_id]': board_id,
               append: fill_rate_from && fill_rate_to ? 'fill_rate' : null,
               include: 'squadsCount',
               fill_rate_from,
               fill_rate_to,
               per_page: 200,
               sort: 'sequence',
               'filter[fill_rates]': only_planning_confirmation ? 'planning-confirmation-approved,presence-show,presence-no-show' : null,
               view,
            },
         })
         .then((response) => response.data);
   },
   async post(body: SquadFilter) {
      return await api.post('/squad-filter', body, { params: { append: 'fill_rate' } }).then((response) => response?.data);
   },
   async patch(squad_filter_id: number, body: Array<{ op: string; path: string; value: any }>) {
      return await api.patch('/squad-filter/' + squad_filter_id, body).then((response) => {
         return response.data;
      });
   },
   async delete(squad_filter_id: number) {
      return await api.delete('/squad-filter/' + squad_filter_id).then((response) => {
         return response.data;
      });
   },
};
